import constate from 'constate'
import { useParams } from 'react-router'
import { useGetPromotionNominationByIdQuery } from '@/features/promotion/promotion.api.ts'

export const [PromotionNominationDetailsProvider, usePromotionNominationDetails] = constate(() => {
  const { promotionNominationId } = useParams() as unknown as { promotionNominationId: number }
  const { data, refetch, isFetching, error } = useGetPromotionNominationByIdQuery({
    id: promotionNominationId,
  }, {
    skip: !promotionNominationId,
  })

  return {
    data: data?.details,
    viewerRole: data?.viewerRole,
    approval: data?.approval,
    refetch,
    isFetching,
    error,
  }
})
